import { autoType, index } from "d3";
import React, { useReducer, useEffect } from "react";
import JoyRide, { ACTIONS, EVENTS, STATUS } from "react-joyride";
import { Icon, Radio } from "semantic-ui-react";
import "./Tour.scss";
import UserManagement_Icon from "../../../assets/svg/Walkthrough-icons/User Management.svg";

const TOUR_STEPS = [
    {
        target: ".activityLogs_step1",
        content: (
            <div style={{ alignItems: "center" }}>
                <div className="header_inline">
                    <img src={UserManagement_Icon} className="tour_image_left"></img> <span className="tour_header">Activity Logs</span>
                    <span className="tour_stepCount">1/4</span>
                </div>
                <p className="tour_content">
                    <iframe
                        width="100%"
                        height="200px"
                        src="https://www.youtube.com/embed/3b4LdFq8IOs"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        className="tour_video"></iframe>
                    <p style={{ paddingTop: "2rem" }}>{`Watch this video to learn about Activity Logs! Or press 'Next' to walkthrough the steps.`}</p>
                </p>
            </div>
        ),
        placement: "right-start",
        disableBeacon: true,
    },
    {
        target: ".activityLogs_step1",
        content: (
            <div style={{ alignItems: "center" }}>
                <div className="header_inline">
                    <img src={UserManagement_Icon} className="tour_image_left"></img> <span className="tour_header">Activity Logs</span>
                    <span className="tour_stepCount">2/4</span>
                </div>
                <p className="tour_content">
                    The Activity Logs helps in getting the logs of the users who have logged into the platform and certain actions performed by them.
                </p>
            </div>
        ),
        placement: "right-start",
        disableBeacon: true,
    },
    {
        target: ".filter-icon_step1",
        content: (
            <div style={{ alignItems: "center" }}>
                <div className="header_inline">
                    <img src={UserManagement_Icon} className="tour_image_left"></img> <span className="tour_header">Filters</span>
                    <span className="tour_stepCount">3/4</span>
                </div>
                <p className="tour_content">This helps in filtering the data by using various parameters under the filters.</p>
            </div>
        ),
        placement: "right-start",
        disableBeacon: true,
    },
    {
        target: ".logs-download_step1",
        content: (
            <div style={{ alignItems: "center" }}>
                <div className="header_inline">
                    <img src={UserManagement_Icon} className="tour_image_left"></img> <span className="tour_header">Downloads</span>
                    <span className="tour_stepCount">4/4</span>
                </div>
                <p className="tour_content">This helps in downloading the data in the CSV format.</p>
            </div>
        ),
    },
];

const INITIAL_STATE = {
    key: new Date(),
    run: false,
    continuous: true,
    loading: false,
    stepIndex: 0,
    steps: TOUR_STEPS,
    checked: true,
};

// Reducer will manage updating the local state
const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case "START":
            return { ...state, run: true };
        case "RESET":
            return { ...state, stepIndex: 0 };
        case "STOP":
            return { ...state, run: false };
        case "NEXT_OR_PREV":
            return { ...state, ...action.payload };
        case "RESTART":
            return {
                ...state,
                stepIndex: 0,
                run: true,
                loading: false,
                key: new Date(),
            };
        default:
            return state;
    }
};

// Tour component
const Tour_activityLogs = () => {
    // console.log('loca',this.props.location)
    // Tour state is the state which control the JoyRide component
    const [tourState, dispatch] = useReducer(reducer, INITIAL_STATE);

    useEffect(() => {
        // Auto start the tour if the tour is not viewed before
        if (!localStorage.getItem("tour")) {
            setTimeout(() => {
                dispatch({ type: "START" });
                return;
            }, 300);
        }
    }, []);

    // Set once tour is viewed, skipped or closed
    const setTourViewed = () => {
        // localStorage.setItem("tour", "1");
    };

    const callback = (data) => {
        const { action, index, type, status } = data;

        if (
            // If close button clicked, then close the tour
            action === ACTIONS.CLOSE ||
            // If skipped or end tour, then close the tour
            (status === STATUS.SKIPPED && tourState.run) ||
            status === STATUS.FINISHED
        ) {
            setTourViewed();
            dispatch({ type: "STOP" });
        } else if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
            // Check whether next or back button click and update the step.
            dispatch({
                type: "NEXT_OR_PREV",
                payload: { stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) },
            });
        }
    };

    const startTour = () => {
        // Start the tour manually
        dispatch({ type: "RESTART" });
    };

    return (
        <>
            {/* <div className="tour_toggle">
                <img src={InteractiveIcon} title="Interactive Help" className="tour-start items-center tour-link" color="blue" onClick={startTour} />
            </div> */}
            <JoyRide
                {...tourState}
                callback={callback}
                scrollToSteps={false}
                disableScrolling={true}
                // showSkipButton={true}
                styles={{
                    options: {
                        arrowColor: tourState.stepIndex == 1 ? "#268af6" : "#fff",
                        padding: 0,
                        margin: 0,
                    },
                    spotlight: {
                        outline: "2px white",
                        outlineStyle: "dashed",
                        // outlineOffset: "2px",
                        zIndex: 4000,
                        position: "fixed",
                        marginLeft: tourState.stepIndex == 0 || tourState.stepIndex == 1 ? "10px" : "auto",
                        marginTop: tourState.stepIndex == 0 || tourState.stepIndex == 1 ? "1px" : "auto",
                        outlineOffset: tourState.stepIndex == 0 || tourState.stepIndex == 1 ? "-3px" : "2px",
                        maxWidth: tourState.stepIndex == 0 || tourState.stepIndex == 1 ? "240px" : "auto",
                    },
                    tooltipContainer: {
                        textAlign: "left",
                        fontSize: "14px",
                        fontFamily: "'Roboto', sans-serif",
                        padding: "0px",
                        backgroundColor: "#268af6",
                        borderRadius: "20px",
                    },
                    buttonBack: {
                        backgroundColor: "rgb(239, 241, 245)",
                        color: "#000000",
                        borderRadius: "4px",
                        marginRight: "5%",
                        fontSize: "14px",
                        fontFamily: "'Roboto', sans-serif",
                    },
                    buttonNext: {
                        backgroundColor: "#268af6",
                        marginRight: tourState.stepIndex == 0 ? "40%" : "30%",
                        fontSize: "14px",
                        fontFamily: "'Roboto', sans-serif",
                        outline: "0px",
                        height: "36px",
                        minWidth: "84px",
                    },
                    buttonClose: {
                        color: "#ffffff",
                        height: "12px",
                        width: "12px",
                        top: "-5px",
                    },
                }}
                locale={{
                    last: "Done",
                    back: "Previous",
                }}
            />
        </>
    );
};

export default Tour_activityLogs;
